import { render, staticRenderFns } from "./AbuWijziging.vue?vue&type=template&id=6f9db0ff&"
import script from "./AbuWijziging.vue?vue&type=script&lang=ts&"
export * from "./AbuWijziging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports